// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__wEEcl","link":"styles_link__P5kT3","table":"styles_table__jJfjp"};